import type { IChartTextProperty } from '../chart-shape-property.interface';
import { IChartDataItem } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-item/data-item.interface';
import type {
    IChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import type {
    IChartLegend,
    IChartManualLayout,
    IChartShapeProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';

export interface ILegendProperty extends IChartTextProperty<IChartLegend>, Pick<IChartLegend, 'layout' | 'position' | 'props'>{
    items: ILegendItem[];

    removeLegend(): void;
    updateLayout(layout: IChartManualLayout): void;
}

export interface ILegendItem {
    name: string;
    paragraphList?: Array<IParagraph>;
    marker: ILegendMarker;
    // 这个type用于图例排序，比如趋势线统一放后面
    type?: string;
    ser: IChartSeries;
    // 如果是每一项对应的legend，则带有dataItem的数据
    dataItem?: IChartDataItem;
}

export interface ILegendMarker {
    symbol: MarkerType;
    props: IChartShapeProps;
}

/**
 * 图例marker类型
 * 通过逆向规则，抽象出几个特征类型。逻辑层使用，最终需要映射到实际的g2类型上
 */
export enum MarkerType {
    MinSquare = 'minSquare',
    Square = 'square',
    Rect = 'rect', // 矩形
    Line = 'hor-line', // 横线
    Circle = 'circle',
}

export type LegendContentType = 'series' | 'category';
